<template>
  <div class="video-box-modal-modal">
    <template v-if="show">
      <div class="static">
        <transition appear name="fade">
          <div class="video-box-modal-backdrop" @click="dismiss" v-if="show"></div>
        </transition>
        <transition appear name="focus">
          <template v-if="show">
            <div class="contents-menu" @close="showVideoModal = false">
              <button @click="dismiss" class="menu-close">Close</button>
              <div class="video-box-modal-outer">
                <div class="video-box-modal-container">
                  <iframe
                    :src="`${videoUrl}?rel=0&amp;controls=1&amp;showinfo=0;&autoplay=1`"
                    width="100%"
                    frameborder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowfullscreen
                  />

                  <!--
                  <div style="padding: 56.25% 0 0 0; position: relative">
                    <iframe
                      src="https://player.vimeo.com/video/135235515?autoplay=1&title=0&byline=0&portrait=0"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                      "
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <script src="https://player.vimeo.com/api/player.js"></script> -->
                </div>
                <div class="video-box-modal-footer">
                  <button @click="dismiss" class="menu-close">
                    Close This Window
                  </button>
                </div>
              </div>
            </div>
          </template>
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    show: {
      required: true,
    },
    items: {
      type: Array,
      required: false,
    },
    videoUrl: {
      tpye: String,
      required: true,
    },
  },
  created() {
    //if process due to the server-side rendering
    if (process.client) {
      const escapeHandler = (e) => {
        if (e.key === "Escape" && this.show) {
          this.dismiss();
        }
      };
      document.addEventListener("keydown", escapeHandler);
      this.$once("hook:destroyed", () => {
        document.removeEventListener("keydown", escapeHandler);
      });
    }
  },
  methods: {
    dismiss() {
      this.$emit("close");
      this.$emit("stop");
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "~@scss/custom.scss";

.static {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10005;
}
//backdrop
.video-box-modal-backdrop {
  background-color: rgba(0, 0, 0, 0.65);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 500;
}

.menu-close {
  all: unset;
  cursor: pointer;
  padding: 1em;
  color: #fff;
}

.contents-menu-header {
  text-align: center;
  margin-bottom: 1.5em;
  h2 {
    font-family: "Source Serif Pro", serif;
  }
}
.contents-menu h4 {
  font-family: "Source Serif Pro", serif;
  margin: 0;
}

.contents-menu {
  padding: 0em 0em;
  position: absolute;
  top: 2em;
  z-index: 10001;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: calc(100% - 2em);
  @include media-breakpoint-up(md) {
    width: calc(100% - 2em);
    max-width: 1280px;
  }
}

//animations
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.focus {
  transform-origin: center;
  --i: 1;
  &-move {
    transition: opacity 0.1s linear, transform 0.3s ease-in-out;
  }

  &-leave-active {
    transition: opacity 0.1s linear,
    transform 0.3s cubic-bezier(0.5, 0, 0.7, 0.4);
    transition-delay: 0s;
  }

  &-enter-active {
    transition: opacity 0.1s linear,
    transform 0.3s cubic-bezier(0.2, 0.5, 0.1, 1);
    transition-delay: 0.1s;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &-enter {
    transform: scale(1.1);
  }
  &-leave-to {
    transform: scale(1.1);
  }
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

//16by9 aspect ratio for video container display
.video-box-modal-container {
  background: var(--vc-card-background-color);
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  z-index: 600;
}
.video-box-modal-outer {
  display: flex;
  flex-direction: column;
}
.video-box-modal-footer {
  text-align: center;
  opacity: 0.5;
}
</style>
